import FakturPenjualanApi from "./FakturPenjualanApi"

export default FakturPenjualanApi